import { render, staticRenderFns } from "./NotifyMe.vue?vue&type=template&id=c1c82c7c&scoped=true"
import script from "./NotifyMe.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifyMe.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotifyMe.vue?vue&type=style&index=0&id=c1c82c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c82c7c",
  null
  
)

export default component.exports